import { theme } from '@faxi/web-component-library';
import { flex } from '@faxi/web-css-utilities';
import { Form } from '@faxi/web-form';
import styled from 'styled-components';

const StyledFindDealerForm = styled(Form)`
  .cedolauto-find-dealer-form {
    &__desc {
      color: var(--BACKGROUND_2_1);
      font-weight: 500;
      flex: 1;

      &__title {
        font-size: ${theme.fontSizes.FONT_28};
        margin-bottom: ${theme.sizes.SIZE_8};
      }

      &__content {
        font-size: ${theme.fontSizes.FONT_20};
        margin-top: 0;
      }
    }

    &__actions {
      ${flex()};

      &__prev-step {
        svg {
          transform: rotate(90deg);
          margin-bottom: ${theme.sizes.SIZE_4};
        }
      }
    }
  }
`;

export { StyledFindDealerForm };
